/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';
import type { ListNotices200ResponseItemsInner } from './ListNotices200ResponseItemsInner';
import {
    ListNotices200ResponseItemsInnerFromJSON,
    ListNotices200ResponseItemsInnerFromJSONTyped,
    ListNotices200ResponseItemsInnerToJSON,
    ListNotices200ResponseItemsInnerToJSONTyped,
} from './ListNotices200ResponseItemsInner';

/**
 * 
 * @export
 * @interface ListNotices200Response
 */
export interface ListNotices200Response {
    /**
     * 
     * @type {Array<ListNotices200ResponseItemsInner>}
     * @memberof ListNotices200Response
     */
    items?: Array<ListNotices200ResponseItemsInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof ListNotices200Response
     */
    paging?: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the ListNotices200Response interface.
 */
export function instanceOfListNotices200Response(value: object): value is ListNotices200Response {
    return true;
}

export function ListNotices200ResponseFromJSON(json: any): ListNotices200Response {
    return ListNotices200ResponseFromJSONTyped(json, false);
}

export function ListNotices200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListNotices200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ListNotices200ResponseItemsInnerFromJSON)),
        'paging': json['paging'] == null ? undefined : ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function ListNotices200ResponseToJSON(json: any): ListNotices200Response {
    return ListNotices200ResponseToJSONTyped(json, false);
}

export function ListNotices200ResponseToJSONTyped(value?: ListNotices200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ListNotices200ResponseItemsInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

